module.exports = __webpack_public_path__ + "img/home_work.2051f73d.png";